import { useNeuronPageViewPush } from "@hooks/useAnalyticsCall/useNeuronPageViewPush";
import useGlobalAdSetting from "@hooks/useGlobalAdSetting/useGlobalAdSetting";
import useRemoveOverlay from "@hooks/useRemoveOverlay";
import { ReactElement, ReactNode } from "react";

export type QuickNewsMainProps = Readonly<{
  testId?: string;
  children: ReactNode;
}>;

/*
 * Container to provide a fixed width and horizontal padding around the content. Typically paired
 * with a Layout component to create reusable templates across all pages. Width of child content as
 * follows with each screen size:

  Viewport width >= 1280: Children component width: 1140px
  Viewport width >= 1024: Children component width: 990px

 * @param {ReactElement} children - Any React Element but likely used to wrap a Tabla module
 * @param {String} testId - Unique string used to target elements when testing
 * @returns {ReactElement} - A wrapped module with a fixed width that resizes on view port resize
 */

export default function QuickNewsContainer({
  children,
  testId = "main-container",
}: QuickNewsMainProps): ReactElement {
  useGlobalAdSetting();
  useNeuronPageViewPush();
  useRemoveOverlay();

  return (
    <main
      data-testid={testId}
      className="max-w-screen relative mx-auto flex h-svh w-screen flex-col overflow-hidden bg-[linear-gradient(168deg,#272727_0%,#101010_100%)] blur-0"
    >
      {children}
    </main>
  );
}
